export const ru: Record<string, string> = {
  "app.title": "Документы",
  "app.subtitle": "Контракты по пунктам",
  "settings.language": "Язык",
  "settings.theme": "Тема",

  "common.loading": "Загрузка…",
  "common.close": "Закрыть",
  "common.back": "Назад",
  "common.error": "Ошибка",
  "common.retry": "Повторить",

  "access.title": "Доступ ограничен",
  "access.body": "Откройте приложение через Telegram-бота по приглашению от администратора.",

  "docs.empty": "Документы пока не загружены.",
  "docs.count": "{n} пунктов",
  "docs.pages": "стр.",

  "doc.search": "Поиск по пунктам…",
  "doc.expand_all": "Развернуть всё",
  "doc.collapse_all": "Свернуть всё",
  "doc.download_title": "Скачать весь документ",
  "doc.no_results": "Ничего не найдено",
  "doc.results": "Найдено: {n}",

  "clause.open": "Открыть",
  "clause.download": "Скачать пункт",
  "clause.speak": "Озвучить",
  "clause.stop": "Стоп",
  "fmt.word": "Word",
  "fmt.pdf": "PDF",

  "download.fail": "Не удалось скачать файл",
  "download.preparing": "Готовим файл…",

  "share.button": "Поделиться",
  "share.download": "Скачать",
  "share.format": "Формат",
  "share.fail": "Не удалось поделиться",
  "share.downloaded": "Файл скачан",

  "tabs.documents": "Документы",
  "tabs.letters": "Письма",
  "tabs.users": "Пользователи",

  "letters.title": "Письма",
  "letters.subtitle": "Официальные письма и отчёты",
  "letters.empty": "Писем пока нет.",
  "letters.doc_date": "Письмо",
  "letters.added": "Добавлено",

  "users.title": "Пользователи и доступ",
  "users.invite_heading": "Пригласить пользователя",
  "users.name_placeholder": "Имя Фамилия",
  "users.make_admin": "Права администратора",
  "users.create": "Создать ссылку-приглашение",
  "users.creating": "Создаём…",
  "users.link_ready": "Одноразовая ссылка (действует 14 дней):",
  "users.copy": "Копировать",
  "users.copied": "Скопировано ✓",
  "users.share": "Поделиться",
  "users.share_text": "Приглашение в приложение «Документы»",
  "users.list_heading": "Пользователи",
  "users.role.admin": "админ",
  "users.role.reader": "читатель",
  "users.active": "активен",
  "users.inactive": "отключён",
  "users.deactivate": "Отключить",
  "users.activate": "Включить",
  "users.empty": "Пока нет пользователей.",
  "users.invite_fail": "Не удалось создать приглашение",
  "users.you": "вы",

  "tabs.files": "Файлы",
  "files.title": "Файлы и папки",
  "files.new_folder": "Новая папка",
  "files.folder_name": "Название папки",
  "files.create": "Создать",
  "files.empty_folders": "Пока нет папок.",
  "files.empty_files": "В этой папке пока нет файлов.",
  "files.upload": "Загрузить файл",
  "files.uploading": "Загрузка…",
  "files.download": "Скачать",
  "files.view": "Просмотр",
  "files.delete": "Удалить",
  "files.confirm_del_folder": "Удалить папку со всеми файлами?",
  "files.confirm_del_file": "Удалить этот файл?",
  "files.count": "{n} файл.",
};
